import React from "react";
import styled from "styled-components";
import { UnitMap, Unit, Floor } from "./UnitMap";

const FloorDescription = styled.div`
  color: #0f0538;
  position: relative;
  top: 30px;
`;

const Engrain = styled.div`
  display: grid;
  font-family: sans-serif;
  grid-template-rows: 0px calc(70vh - 53px);
  grid-template-areas:
  "floor-picker floor-picker"
  "unit-list main";
  justify-content: center;
  height: 350px;
  
  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakLaptop}) {
    grid-template-columns: 20px calc(100vw - 50px);
    grid-template-rows: 0px calc(50vh - 43px);
  }
`
const Main = styled.div`
  grid-area: main;
  width: 100%;
  height: 100%;
`

function EngrainMap({ data, activeUnit, info = null }) {
   const processedActiveUnits = Array.isArray(activeUnit)
  ? activeUnit.map((unit) => {
      const parts = unit.split('-');
      // Return the part after the hyphen (entrata), or the unit itself if no hyphen 
      return parts.length > 1 ? parts[1] : unit;
    })
  : [activeUnit];

  return (
    <>
      <Engrain className="Engrain">
        <Main className="Main">
          <UnitMap id={data.mapId} apiKey={data.apiKey} height="100%">
            <Floor id={data.floorId} />
            {data.units && data.units.length > 0 && data.units.map((unit) => {
              if(info === 'specificUnit') {
                 unit.color = "#808080"
              }
              if (processedActiveUnits != undefined && processedActiveUnits.includes(unit.unit_number)) {
                unit.color = "#42ACCD"
              } 
              return <Unit
                key={unit.id}
                id={unit.id}
                color={unit.color}
              />
            }
            )}
          </UnitMap>
        </Main>
      </Engrain>
      {data.description && (
        <FloorDescription className="FloorDescription">
          <span>{data.description}</span>
        </FloorDescription>
      )}
    </>
  );
}

export default EngrainMap;
